<template>
  <div class="shouyin">
  	<meta name="description" content="以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"/>
		<title>订单支付-以诺教育</title>
  	<headTop></headTop>
    <div id="PaymentOrder">
      <div class="imagess"></div>
      <div class="Order" v-for="item in list">
        <div class="zhorderNumber">
          <div class="numCon">
            <p class="number">订单已生成！订单号：{{item.order_id}}</p>
            <p class="zhcontents">
	            	课程名称：{{item.name}}
	            <br/>
	            	 下单时间：{{item.order_date}}
            </p>
          </div>
          <div class="paymentt">
            <p class="pay">待支付</p>
            <p class="payNowo">￥{{item.unit_price}}</p>
          </div>
         </div>

        <div class="close" id="closeT"></div>
      </div>
 			</div>
      <div class="platform">
          <div class="payplatform actives" @click="handle1">支付平台</div>
          <div class="payplatform payplatformTwo" @click="handle2">银行转账</div>

      </div>
      <div class="clears"></div>
       <div class="payCon" v-show="pay1">
       			<ul class="select">
       				   <li class="wx"><p class="patch1 activeT" style="border-color: rgb(17, 204, 153);"><i style="display:block"></i></p><span></span></li>
       				   <li class="zfb"><p class="patch2"><i></i></p><span></span></li>
       				   <div class="zftishi">温馨提醒：如果订单金额超过线上支付限额，推荐银行转账支付。</div>
       			</ul>
       			<div class="next">
                <div @click="zhmask" v-if="wxzf"><router-link :to="{name:'paymentQR',params:{id:hao}}" target="_blank" class="nextStep">下一步</router-link></div>
                <div v-if="zfbzf" class="nextStep" @click="zfbzfb">下一步</div>
            </div>
       </div>
        <div class="clears"></div>
       <div class="payCon account" v-show="pay2">
            <div class="card">
            	  <div class="paycard"></div>
            	  <p class="label" v-for="item in list">汇款备注请注明<span>“订单号{{item.order_id}}”</span></p>

            	  <p class="label1">请及时与客服联系确认到账情况</p>
            </div>
            <p class="prompt">提示:如您选择线下转账，请在订单有效期内完成打款，如打款后订单状态未更新或未收到订单到账通知，</p>
            <div class="next zhClose">
                <div class="nextStep"><router-link to="/orderList">关闭</router-link></div>
            </div>
       </div>
      <div class="zhMask" v-show="zhMask">
        <div class="zhPaymentResults" v-show="!zhJudge">
          <p class="zhPayment">支付结果</p>
          <p class="zhResults">请您在新打开的页面上完成付款,付款完成前请不要关闭此窗口。完成付款后请根据您的情况点击下面的按钮：</p>
          <div class="zhButton">
            <div class="zhBut" @click="zhbut">支付成功</div>
            <div class="zhZhifu" @click="zhzhifu">支付失败，继续支付 ></div>
          </div>
          <div class="zhCloses" @click="zhmaskes">
            <div class="zhC"></div>
            <div class="zhC zhC1"></div>
          </div>
        </div>
        <div class="zhPaymentResults" v-show="zhJudge">
          <p class="zhPayment">支付结果</p>
          <p class="zhResults">抱歉，当前尚未收到银行或第三方平台的支付确认，为 避免重复支付，请确认您的银行卡或平台账户是否已经扣款。如已扣款请联系以诺平台客服 4008200025-6 进行处理。</p>
          <div class="zhButton zhActive">
            <div class="zhBut" @click="clock">我知道了</div>
          </div>
          <div class="zhCloses" @click="zhmaskes">
            <div class="zhC"></div>
            <div class="zhC zhC1"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import headTop from "../headTop/headTop"
export default {
  name: 'PaymentOrder',
  components:{headTop},
  data () {
    return {
    	weixin:"wx",
      pay1:true,
      pay2:false,
      hao:this.$route.params.id,
      list:[],
      time:'',
      zhJudge:false,
      zhMask:false,
      wxzf:true,
      zfbzf:false,
    }
  },
  mounted(){
        var that = this;
			$(".patch1").click(function(){
				  $(this).css({"borderColor":"#11cc99"})
				  $(".patch2").css({"borderColor":"#dfdfdf"})
				  $(".patch1 i").css({"display":"block"})
				  $(".patch2 i").css({"display":"none"})
				  that.wxzf=true
      		that.zfbzf=false
			})
			$(".patch2").click(function(){
				  $(this).css({"borderColor":"#11cc99"})
				  $(".patch1").css({"borderColor":"#dfdfdf"})
				  $(".patch2 i").css({"display":"block"})
				  $(".patch1 i").css({"display":"none"})
				  that.wxzf=false
      		that.zfbzf=true
			})
      $(".payplatform").click(function(){
        $(".payplatform").removeClass("actives")
        $(this).addClass("actives")
      })
			/*-------------------------------订单信息--------------------------------------*/
			  that.$ajax({
			  	  method:"post",
			  	  url:"/api/MyOrderDetail",
			  	  params:{id:that.hao}
			  }).then(function(data){
			  	that.list=data.data.result
			  	that.time=data.data.result[0].pending_paytime
			/*-------------------------------倒计时--------------------------------------*/
			 function timer(intDiff){
    window.setInterval(function(){
    var day=0,
        hour=0,
        minute=0,
        second=0;//时间默认值
    if(intDiff > 0){
        day = Math.floor(intDiff / (60 * 60 * 24));
        hour = Math.floor(intDiff / (60 * 60)) - (day * 24);
        minute = Math.floor(intDiff / 60) - (day * 24 * 60) - (hour * 60);
        second = Math.floor(intDiff) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60);
    }
    if (minute <= 9) minute = '0' + minute;
    if (second <= 9) second = '0' + second;
    if(day > 0){
      $('.close').html("请在"+'<s id="h"></s>'+day+'天'+'<s></s>'+'<s id="h"></s>'+hour+':'+'<s></s>'+minute+':'+'<s></s>'+second+''+"内支付，逾时订单将自动关闭");
    } else{
      $('.close').html("请在"+'<s id="h"></s>'+hour+':'+'<s></s>'+minute+':'+'<s></s>'+second+''+"内支付，逾时订单将自动关闭");
    }
    intDiff--;
    }, 1000);
}
		$(function(){
					timer(that.time)
			})
	})

    //最小屏宽
    var minHeight = $(window).height() + 'px';
    $('body').css({"min-height":minHeight});
    /*---------------------------------刷新---------------------------------*/
     if(sessionStorage.getItem("xin")==1){
     	  location.reload()
     	  sessionStorage.setItem("xin",0)
     }
  },
  methods:{
      handle1: function () {
          this.pay1 = true;
          this.pay2 = false;
      },
      handle2: function () {
          this.pay1 =false ;
          this.pay2 = true;
      },
      zhmask:function (){
      	var that=this
        that.$ajax({
				method:'post',
				url:'/api/QrCodeGet',
				params:{order_id:that.hao}
			}).then(function(data){
				if(data.data.error){
					alert(data.data.error.message)
				}else{
					that.zhMask = true;
        	that.zhJudge = false;
				}
			}).catch(function(err){
				console.log(err)
		})
    },
    zfbzfb(){
    	var that=this
    	let arrty=window.open()
    	 /*-----------------------------------支付宝支付-----------------------------------*/
        that.$ajax({
				method:'post',
				url:'/api/alipay',
				params:{order_id:that.hao}
			}).then(function(data){
					arrty.location.href=data.data
			}).catch(function(err){
				console.log(err)
		})
    },
      zhmaskes:function (){
        this.zhMask = false;
      },
      zhbut:function (){
      	var that=this
       that.$ajax({
       	method:"post",
       	url:"api/MyOrderDetail",
       	params:{id:that.hao}
       }).then(function(data){
       	if(data.data.result[0].order_status==2){
       			that.$router.push({name:'orderDetail',params:{id:that.hao}})
       	}else if(data.data.result[0].order_status==1){
					that.zhJudge = true;
       	}
       }).catch(function(err){
       	  console.log(err)
       })
       },
      clock:function(){
        this.zhMask = false;
      },
      zhzhifu:function(){
        this.zhMask = false;
      },
    }

}
</script>
<style scoped>
  .shouyin{background:#F4F5F9;padding-bottom:30px;}
  #PaymentOrder{width:100%;background:#f4f5f9;padding:1px 0 50px 0;box-sizing:border-box;}
  .imagess{width:960px;height:65px;box-sizing:border-box;margin:30px auto;background:url(../../assets/jindutiao.png) no-repeat 140px -160px;}
  .Order{width:960px;height:191px;background:#ffffff;margin:0 auto;}
  .zhorderNumber{width:960px;;height:138px;padding:23px 30px;box-sizing:border-box;border-bottom:1px solid #e6e6e6;}
  .numCon{width:600px;float:left;}
  .number{font-size:20px;color:#4f4f4f;padding-top:15px;}
  .zhcontents{font-size:14px;color:#909090;padding-top:15px;}
  .paymentt{width:210px;float:right;height:100%;border-left:1px solid #e6e6e6;box-sizing:border-box;}
  .pay{font-size:14px;color:#4f4f4f;padding-left:30px;}
  .payNowo{font-size:32px;color:#4f4f4f;padding:15px 0;margin-left:30px;}
  .close{padding:18px 30px;color:#ff5050;}
  .platform{width:960px;margin:40px auto 0;height:50px;position:relative;}
  .payplatform{width:202px;height:50px;cursor:pointer;background:#e4e6f1;position:absolute;bottom:0;display:flex;justify-content:center;align-items:center;font-size:18px;color:#909090;font-weight:500;transition:.2s ease;}
  .payplatformTwo{left:202px;}
  .clears{clear:both;}
  .actives{height:60px;background:#ffffff;color:#01b784;}
  .payCon{width:960px;background:#ffffff;margin:0 auto;}
  .next{cursor:pointer;width:960px;height:90px;display:flex;justify-content:center;align-items:center;border-top:1px solid #e6e6e6;margin:0 auto;background:#fff;}
  .nextStep{width:200px;height:50px;background:#11cc99;color:#ffffff;font-size:16px;font-weight:600;border-radius:5px;display:flex;justify-content:center;align-items:center;}
  .card{width:490px;height:410px;margin:0 auto;position: absolute;top:70px;left:50%;margin-left:-245px;}
  .account{height:570px;position: relative;}
  .paycard{width:490px;height:270px;background:url(../../assets/pament.png)no-repeat -20px -176px;}
  .prompt{text-align: center;font-size: 16px;color:#4f4f4f;width:750px;position: absolute;top:400px;left:100px;}
  .label{text-align: center;margin-top:15px;font-size: 16px;color:#4f4f4f;}
  .label1{text-align: center;margin-top:55px;font-size: 16px;color:#4f4f4f;}
  .select{height:160px;padding-top:30px;}
  .select li{float:left;}
  .select li p{width:28px;height:28px;border-radius: 50%;border:1px solid #dfdfdf;}
  .select li span{width:160px;height:60px;display:block;border:1px solid #e6e6e6;}
  .zftishi{clear: both;padding:20px 0 0 30px;color: #909090;}
  .wx p{float:left;margin:10px 20px 0 40px;}
  .select .zfb p{float:left;margin:10px 20px 0 50px;}
  .wx span{background:url(../../assets/pament.png)no-repeat -20px -100px;float:left;}
  .select .zfb span{background:url(../../assets/pament.png)no-repeat -20px -20px;float:left;}
  .patch1 i,.patch2 i{width:18px;height:18px;border-radius: 50%;background:#11cc99;display:none;margin:4px;}
  .zhClose{position: absolute;top:480px;left:0;}
  a:visited{color:#fff;}
  a{color:#ffffff;}
  .zhMask{width:100%;height:100%;background:rgba(0,0,0,.5);position: fixed;top:0;left:0;display: flex;justify-content: center;align-items: center}
  .zhPaymentResults{width:400px;background:#ffffff;box-sizing: border-box;padding:30px 30px 40px 30px;position: relative;}
  .zhPayment{width:100%;font-size:18px;color:#4f4f4f;font-weight:bold;}
  .zhResults{width:100%;box-sizing: border-box;padding:30px 0;font-size:14px;color:#4f4f4f;}
  .zhButton{width:100%}
  .zhBut{cursor:pointer;float:left;width:150px;height:36px;background:#00b983;border-radius: 5px;display: flex;justify-content: center;align-items: center;font-size:14px;color:#ffffff;}
  .zhZhifu{float:left;font-size:14px;color:#00b983;line-height: 28px;margin-left:30px;cursor:pointer;}
  .zhCloses{width:16px;height:16px;position: absolute;top:30px;right:30px;cursor:pointer;}
  .zhC{width:2px;background:#90908f;height:20px;position: absolute;top:0;left:50%;transform:rotate(-45deg);}
  .zhC1{transform:rotate(45deg);}
  .zhActive{display: flex;justify-content: center;align-items: center;}
  .activeT{}
</style>



// WEBPACK FOOTER //
// PaymentOrder.vue?1b18b94a